import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContentVersion from "./ContentVersion";
import type JournalistEnquiryRecipient from "./JournalistEnquiryRecipient";
import type TwitterUser from "./TwitterUser";

@Model()
class Journalist extends ApplicationRecord {
  static jsonapiType = "journalists";

  @Attr() alternateEmails: string[];

  @Attr() alternateNames: string[];

  @Attr() avatarUrl: string;

  @Attr() bio: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() email: string;

  @Attr() facebookUrl: string;

  @Attr() firstName: string;

  @Attr() hiddenReason: string;

  @Attr() instagramHandle: string;

  @HasMany() journalistEnquiryRecipients: JournalistEnquiryRecipient[];

  @Attr() lastName: string;

  @Attr() lastScraped: string;

  @Attr() lastUpdatedBy: string;

  @Attr() linkedinUrl: string;

  @Attr() name: string;

  @Attr() notes: string;

  @Attr() phone: string;

  // extra attributes
  @Attr() primaryJobTitle: string;

  @Attr() primarySourceName: string;

  @Attr() publisherGroups: string[];

  @Attr() reviewedAt: string;

  @Attr() secondaryEmails: string[];

  @Attr() secondarySourceNames: string[];

  @Attr() twitterUrl: string;

  @BelongsTo() twitterUser: TwitterUser;

  @Attr() twitterUserId: string;

  @Attr() twitterUsername: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() urlHash: string;

  @HasMany() versions: ContentVersion[];

  @Attr() visible: boolean;
}

export default Journalist;
